import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from 'react-query';
import { generateUtmExt } from '../../Common/Common';

import axiosInstance from '../../Store/helper/axiosInstance';

import {
  MODULE_LIST,
  SPECIALITY_TRAINING,
  TOP_SPECIALITY,
  TRAINING_COMPLETED,
  TRAINING_COUNT,
  TRAINING_DETAILS,
  TRAINING_FEATURED,
  TRAINING_INCOMPLETED,
  TRAINING_LIST,
  TRAINING_POPULAR,
  TRAINING_REVIEWS,
  TRAINING_STATUS
} from '../QueryKeys/training.key';

const cacheTime = 600000;
// incomplete;
// complete;
// featured;
const returnQueryKeys = (type) => {
  switch (type) {
    case 'featured':
      return TRAINING_FEATURED;
    case 'completed':
      return TRAINING_COMPLETED;
    case 'incompleted':
      return TRAINING_INCOMPLETED;

    default:
      return TRAINING_POPULAR;
  }
};
export const useTrainingFeatured = (type, onSuccess, onError) => {
  return useQuery(
    returnQueryKeys(type),
    () =>
      axiosInstance.get(
        type ? `training/listing?from=0&to=10&type=${type}` : 'training/listing?from=0&to=10'
      ),
    {
      onSuccess,
      refetchOnWindowFocus: false,

      onError,
      select: (response) => response.data.data,

      cacheTime: cacheTime
    }
  );
};
export const useTrainingCount = (onSuccess, onError) => {
  return useQuery(TRAINING_COUNT, () => axiosInstance.get('training/count'), {
    onSuccess,
    refetchOnWindowFocus: false,

    onError: () => {},
    select: (response) => response.data.data,

    cacheTime: cacheTime
  });
};
export const useTrainingList = (type, speciality, onSuccess, onError, enabled) => {
  return useInfiniteQuery(
    [TRAINING_LIST, type, speciality],
    ({ pageParam = 0 }) =>
      axiosInstance.get(
        speciality
          ? `training/listing?from=${pageParam}&to=10&spids=${speciality}${
              type ? '&type=' + type : ''
            }`
          : `training/listing?from=${pageParam}&to=10${type ? '&type=' + type : ''}`
      ),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
      cacheTime: cacheTime,
      enabled,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length <= 10) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
    }
  );
};
//module_list?type_id=20
export const useTrainingModuleList = (type_id, onSuccess, onError) => {
  return useQuery(
    [MODULE_LIST, type_id],
    () => axiosInstance.get(`training/module_list?id=${type_id}`),
    {
      onSuccess,
      refetchOnWindowFocus: false,

      select: (res) => res.data.data,
      onError: () => {},

      cacheTime: cacheTime
    }
  );
};
export const useTrainingDetails = (type_id, onSuccess, onError, enabled = true) => {
  return useQuery(
    [TRAINING_DETAILS, type_id],
    () => axiosInstance.get(`training/detail?id=${type_id}${generateUtmExt()}`),
    {
      onSuccess,
      onError,
      select: (response) => response.data.data,
      enabled,
      cacheTime: cacheTime,
      refetchOnWindowFocus: false
    }
  );
};
export const useTrainingReviews = (type_id, onSuccess, onError) => {
  return useQuery(
    [TRAINING_REVIEWS, type_id],
    () => axiosInstance.get(`training/getreview?id=${type_id}`),
    {
      onSuccess,
      onError,
      select: (response) => response.data.data,
      refetchOnWindowFocus: false,
      cacheTime: cacheTime
    }
  );
};
//https://dockerapidev.clirnet.com/rnv32/training/getreview?id=1
export const useTopSpecialities = (type, onSuccess, onError) => {
  return useQuery(
    [TOP_SPECIALITY, type],
    () => axiosInstance.get(`topspeciality/data?type=${type}`),
    {
      onSuccess,
      onError,
      select: (response) => response.data.data,
      refetchOnWindowFocus: false,
      cacheTime: cacheTime
    }
  );
};

export const useTrainingStatusPercentage = (training_id, enabled, onSuccess, onError) => {
  return useQuery(
    [TRAINING_STATUS, training_id],
    () => axiosInstance.get(`training/showviewstatus?training_id=${training_id}`),
    {
      onSuccess,
      enabled,
      onError,
      select: (response) => Math.round(parseFloat(response?.data?.data ?? 0)),
      cacheTime: cacheTime,
      refetchOnWindowFocus: false
    }
  );
};
//listing?from=0&to=10&type=featured
//topspeciality/data?type=${type}

// SPECIALITY HOOKS

const saveLike = (data) => {
  return axiosInstance.post('knwlg/save_like', data);
};

export const useAddSpecialityTrainingLike = (type_id) => {
  const queryClient = useQueryClient();

  return useMutation(saveLike, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION SAVELIKE', obj);
      const queryKeysArr = [SPECIALITY_TRAINING, type_id];
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        return {
          ...oldQueryData,
          data: {
            ...oldQueryData.data,
            data: {
              ...oldQueryData.data.data,
              rating: oldQueryData.data.data.myrating
                ? oldQueryData.data.data.rating - 1
                : oldQueryData.data.data.rating + 1,
              myrating: !oldQueryData.data.data.myrating
            }
          }
        };
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {},
    onSettled: () => {
      queryClient.invalidateQueries([SPECIALITY_TRAINING, type_id]);
    }
  });
};
